import React from 'react';
import { Icon } from 'antd';
import VolumeManager from '../components/VolumeManager';
import { percentage } from '../helpers';
import { AVAILABLE_VOLUME_DATA_SOURCES, DATA_IS_LINKED } from '../plannerConfig';

export const WEEK_DAYS = {
  mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6, sun: 7,
};

export const FRIENDLY_WEEK_DAY_ARRAY = [
  { label: 'Monday', value: 'mon' },
  { label: 'Tuesday', value: 'tue' },
  { label: 'Wednesday', value: 'wed' },
  { label: 'Thursday', value: 'thu' },
  { label: 'Friday', value: 'fri' },
  { label: 'Saturday', value: 'sat' },
  { label: 'Sunday', value: 'sun' },
];

export const EXTRA_DATA_PAGES = {
  volumeManager: {
    name: 'Volume Manager',
    icon: <Icon type="profile" />,
    component: props => <VolumeManager {...props} />,
    api: {
      get: {
        routes: [AVAILABLE_VOLUME_DATA_SOURCES, DATA_IS_LINKED],
        params: ({volumeType}) => ({
          volumeType,
          days: Object.keys(WEEK_DAYS),
        }),
      },
    },
  },
};

export const VOLUME_MODIFIERS = {
  none: {
    name: 'None',
    required: false,
    f: (value, _) => value,
    max: () => { },
  },
  set: {
    name: 'Set',
    required: true,
    f: (_, amount) => amount,
    max: () => { },
  },
  up: {
    name: 'Up',
    required: true,
    f: (value, amount) => value + amount,
    max: () => { },
  },
  down: {
    name: 'Down',
    required: true,
    f: (value, amount) => value - amount,
    max: volume => volume,
  },
  u_percent: {
    name: 'Up %',
    required: true,
    f: (value, amount) => Math.round(value + percentage(value, amount)),
    max: () => { },
  },
  d_percent: {
    name: 'Down %',
    required: true,
    f: (value, amount) => Math.round(value - percentage(value, amount)),
    max: () => 100,
  },
};
